import type { CustomerOriginQueryParamValue } from '@apps/main/new-desktop/core/models/navigation';

import type { Serializer } from '@libs/utils';

export const CustomerOriginSerializer: Serializer<CustomerOriginQueryParamValue> =
  {
    serialize: (
      customerOrignQueryParam: CustomerOriginQueryParamValue
    ): CustomerOriginQueryParamValue => customerOrignQueryParam,
    deserialize: (
      customerOrignQueryParam: CustomerOriginQueryParamValue
    ): CustomerOriginQueryParamValue => customerOrignQueryParam,
  };
